export enum ActivityType {
  PRACTICE = 'PRACTICE',
  POLL = 'POLL',
  MENTOR_FORM = 'MENTOR_FORM',
  CHAT = 'CHAT',
  THERAPY_MEETING = 'THERAPY_MEETING',
}

export enum TrackingType {
  STOPWATCH = 'STOPWATCH',
  RETROACTIVE = 'RETROACTIVE',
}

export enum StartReason {
  TASK_OPENED = 'TASK_OPENED',
  THERAPIST = 'THERAPIST',
}

export enum EndReason {
  KEEPALIVE = 'KEEPALIVE',
  TASK_CLOSED = 'TASK_CLOSED',
  THERAPIST = 'THERAPIST',
}

export type TimeTracking = {
  _id: string;
  userId: string;
  mentorId: string;
  trackingType: TrackingType;
  activityType: ActivityType;
  activityId: string | null;
  startTime: string;
  startReason: StartReason;
  endTime: string;
  endReason: EndReason;
  duration: number;
};

export type CreateTimeTrackingRecord = Omit<TimeTracking, '_id'>;
export type UpdateTimeTrackingRecord = Pick<TimeTracking, '_id' | 'endTime' | 'endReason' | 'duration'>;
